import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import {
	brandPrimary,
	brandSecondary,
	campaignTintColor,
	customAutomationTint,
	emailActivityTintColor,
	eventTintColor,
	kitTintColor,
	noteTintColor,
	success,
} from '../../../../styles/colors';
import { NewDonorIcon } from '../DonorIcons/NewDonorIcon';
import { SvgIcon } from '../SvgIcon';
import { TextingIcon } from '../TextingIcon';
import { styleSheet } from './styles';

interface IProps {
	circleStroke?: string;
	className?: string;
	styles?: StyleDeclarationValue[];
	trigger?: Api.IAutomationTrigger;
}

export const AutomationTriggerIcon: React.FC<IProps> = props => {
	const { className, styles, trigger, circleStroke: propsCircleStroke } = props;

	let circleStroke: string = null;
	let path: React.ReactNode = null;
	switch (trigger?._type) {
		case Api.AutomationTriggerType.EventRegistration: {
			circleStroke = eventTintColor;
			path = (
				<path
					transform='translate(8, 7)'
					d='M14.3976,14.4 L1.6,14.4 L1.6,5.6 L14.3992,5.6 L14.3976,14.4 Z M14.4,2.4 L13.6,2.4 L13.6,0 L12,0 L12,4 L11.2,4 L11.2,2.4 L5.6,2.4 L5.6,0 L4,0 L4,4 L3.2,4 L3.2,2.4 L1.6,2.4 C0.7176,2.4 0,3.1184 0,4 L0,14.4 C0,15.2824 0.7176,16 1.6,16 L14.4,16 C15.2824,16 16,15.2824 16,14.4 L16,4 C16,3.1184 15.2824,2.4 14.4,2.4 L14.4,2.4 Z'
					fill={circleStroke}
				/>
			);
			break;
		}
		case Api.AutomationTriggerType.Meeting: {
			circleStroke = noteTintColor;
			path = (
				<path
					transform='translate(8, 7)'
					d='M14.3976,14.4 L1.6,14.4 L1.6,5.6 L14.3992,5.6 L14.3976,14.4 Z M14.4,2.4 L13.6,2.4 L13.6,0 L12,0 L12,4 L11.2,4 L11.2,2.4 L5.6,2.4 L5.6,0 L4,0 L4,4 L3.2,4 L3.2,2.4 L1.6,2.4 C0.7176,2.4 0,3.1184 0,4 L0,14.4 C0,15.2824 0.7176,16 1.6,16 L14.4,16 C15.2824,16 16,15.2824 16,14.4 L16,4 C16,3.1184 15.2824,2.4 14.4,2.4 L14.4,2.4 Z'
					fill={circleStroke}
				/>
			);
			break;
		}
		case Api.AutomationTriggerType.Texting: {
			return (
				<span
					className={css(styleSheet.textingTriggerIcon)}
					style={propsCircleStroke ? { borderColor: propsCircleStroke } : undefined}
				>
					<TextingIcon fill={propsCircleStroke || brandPrimary} />
				</span>
			);
		}
		case Api.AutomationTriggerType.NewDonationTrigger:
		case Api.AutomationTriggerType.NewDonor: {
			return <NewDonorIcon />;
		}
		case Api.AutomationTriggerType.NewClient: {
			const t = trigger as Api.INewClientAutomationTrigger;
			const newClientType: Api.NewClientType = t.clientType?.[0] || Api.NewClientType.Unknown;
			switch (newClientType) {
				case Api.NewClientType.Personal: {
					circleStroke = brandPrimary;
					path = (
						<path
							d='M19.7109 13.918C19.7109 14.9297 19.3646 15.709 18.6719 16.2559C17.9837 16.7982 16.9971 17.0693 15.7119 17.0693H14.5361V21H13.374V11.0059H15.9648C18.4622 11.0059 19.7109 11.9766 19.7109 13.918ZM14.5361 16.0713H15.582C16.612 16.0713 17.3571 15.9049 17.8174 15.5723C18.2777 15.2396 18.5078 14.7064 18.5078 13.9727C18.5078 13.3118 18.2913 12.8197 17.8584 12.4961C17.4255 12.1725 16.751 12.0107 15.835 12.0107H14.5361V16.0713Z'
							fill={circleStroke}
						/>
					);
					break;
				}
				case Api.NewClientType.Commercial: {
					circleStroke = brandPrimary;
					path = (
						<path
							d='M16.6533 11.9014C15.555 11.9014 14.6868 12.2682 14.0488 13.002C13.4154 13.7311 13.0986 14.7314 13.0986 16.0029C13.0986 17.3109 13.404 18.3226 14.0146 19.0381C14.6299 19.749 15.5049 20.1045 16.6396 20.1045C17.3369 20.1045 18.1322 19.9792 19.0254 19.7285V20.7471C18.3327 21.0068 17.4782 21.1367 16.4619 21.1367C14.9899 21.1367 13.8529 20.6901 13.0508 19.7969C12.2533 18.9036 11.8545 17.6344 11.8545 15.9893C11.8545 14.9593 12.0459 14.057 12.4287 13.2822C12.8161 12.5075 13.3721 11.9105 14.0967 11.4912C14.8258 11.0719 15.6826 10.8623 16.667 10.8623C17.7152 10.8623 18.6312 11.0537 19.415 11.4365L18.9229 12.4346C18.1663 12.0791 17.4098 11.9014 16.6533 11.9014Z'
							fill={circleStroke}
						/>
					);
					break;
				}
				default: {
					circleStroke = brandSecondary;
					path = (
						<>
							<path
								d='M21.6364 22.0667V20.6444C21.6364 19.0735 20.3339 17.8 18.7273 17.8H12.9091C11.3024 17.8 10 19.0735 10 20.6444V22.0667'
								stroke='#00AAE8'
								strokeLinecap='round'
								strokeLinejoin='round'
							/>
							<ellipse
								cx='16.1091'
								cy='11.8444'
								rx='2.90909'
								ry='2.84444'
								stroke={circleStroke}
								strokeLinecap='round'
								strokeLinejoin='round'
							/>
						</>
					);
					break;
				}
			}
			break;
		}
		case Api.AutomationTriggerType.NewLead: {
			circleStroke = success;
			path = (
				<path
					d='M19.082 17.93c0 .62-.232 1.133-.697 1.539-.465.4-1.115.654-1.949.758v1.587h-.881v-1.525a9.34 9.34 0 01-1.484-.116c-.478-.082-.87-.194-1.175-.335V18.77c.378.17.813.308 1.305.418a6.61 6.61 0 001.354.157v-3.008c-.935-.296-1.59-.64-1.97-1.032-.373-.392-.56-.898-.56-1.518 0-.597.23-1.087.69-1.47.466-.383 1.079-.615 1.84-.697v-1.244h.881v1.23a6.938 6.938 0 012.427.506l-.355.896a6.94 6.94 0 00-2.072-.479v2.967c.716.228 1.252.451 1.607.67.355.214.617.463.786.745.169.278.253.618.253 1.019zm-1.162.09c0-.329-.103-.593-.308-.793-.2-.206-.592-.408-1.175-.609v2.66c.988-.137 1.483-.557 1.483-1.258zm-3.74-4.246c0 .347.103.625.308.834.205.21.56.408 1.067.595v-2.645c-.451.072-.793.216-1.026.43-.232.21-.348.472-.348.786z'
					fill={circleStroke}
				/>
			);
			break;
		}
		case Api.AutomationTriggerType.NewPolicyTrigger:
		case Api.AutomationTriggerType.ResourceSelector: {
			const t = trigger as Api.IResourceSelectorAutomationTrigger | Api.INewPolicyTrigger;
			switch (t.resourceSelector) {
				case Api.ResourceSelectorId.Turning72:
				case Api.ResourceSelectorId.Turning73: {
					circleStroke =
						t.resourceSelector === Api.ResourceSelectorId.Turning72 ||
						t.resourceSelector === Api.ResourceSelectorId.Turning73
							? noteTintColor
							: emailActivityTintColor;
					path = (
						<path
							fill={circleStroke}
							d='M9.91666667 12.8183125L1.75 12.8183125C1.42858333 12.8183125 1.16666667 12.5563958 1.16666667 12.2349792L1.16666667 10.7433958C1.51141667 10.9446458 1.90633333 11.0683125 2.33333333 11.0683125 3.02925 11.0683125 3.65575 10.7620625 4.08333333 10.2773125 4.51091667 10.7620625 5.13741667 11.0683125 5.83333333 11.0683125 6.52925 11.0683125 7.15575 10.7620625 7.58333333 10.2773125 8.01091667 10.7620625 8.63741667 11.0683125 9.33333333 11.0683125 9.76033333 11.0683125 10.15525 10.9446458 10.5 10.7433958L10.5 12.2349792C10.5 12.5563958 10.2380833 12.8183125 9.91666667 12.8183125L9.91666667 12.8183125zM10.5 8.73497917C10.5 9.37839583 9.97675 9.90164583 9.33333333 9.90164583 8.68991667 9.90164583 8.16666667 9.37839583 8.16666667 8.73497917 8.16666667 8.41297917 7.90533333 8.15164583 7.58333333 8.15164583 7.26133333 8.15164583 7 8.41297917 7 8.73497917 7 9.37839583 6.47675 9.90164583 5.83333333 9.90164583 5.18991667 9.90164583 4.66666667 9.37839583 4.66666667 8.73497917 4.66666667 8.41297917 4.40533333 8.15164583 4.08333333 8.15164583 3.76133333 8.15164583 3.5 8.41297917 3.5 8.73497917 3.5 9.37839583 2.97675 9.90164583 2.33333333 9.90164583 1.68991667 9.90164583 1.16666667 9.37839583 1.16666667 8.73497917L1.16666667 7.5683125 10.5 7.5683125 10.5 8.73497917zM11.0833333 6.40164583L.583333333 6.40164583C.261333333 6.40164583 0 6.66297917 0 6.98497917L0 12.2349792C0 13.1998125.785166667 13.9849792 1.75 13.9849792L9.91666667 13.9849792C10.8815 13.9849792 11.6666667 13.1998125 11.6666667 12.2349792L11.6666667 6.98497917C11.6666667 6.66297917 11.4053333 6.40164583 11.0833333 6.40164583L11.0833333 6.40164583zM9.91666667 1.64952083C10.2526667 2.21535417 10.4953333 2.7234375 10.5 2.90135417 10.5 3.22335417 10.2380833 3.4846875 9.91666667 3.4846875 9.59525 3.4846875 9.33333333 3.22335417 9.33333333 2.9019375 9.338 2.72402083 9.58066667 2.2159375 9.91666667 1.64952083M9.33333333 4.54402083L9.33333333 5.81802083 10.5 5.81802083 10.5 4.54402083C11.17725 4.30252083 11.6666667 3.66085417 11.6666667 2.90135417 11.6666667 2.15585417 10.77825.7896875 10.39675.2366875 10.1791667-.0788958333 9.65416667-.0788958333 9.43658333.2366875 9.0545.7896875 8.16666667 2.15585417 8.16666667 2.90135417 8.16666667 3.66085417 8.6555 4.30252083 9.33333333 4.54402083M1.75 1.64952083C2.086 2.21535417 2.32866667 2.7234375 2.33333333 2.90135417 2.33333333 3.22335417 2.07141667 3.4846875 1.75 3.4846875 1.42858333 3.4846875 1.16666667 3.22335417 1.16666667 2.9019375 1.17133333 2.72402083 1.414 2.2159375 1.75 1.64952083M1.16666667 4.54402083L1.16666667 5.81802083 2.33333333 5.81802083 2.33333333 4.54402083C3.01058333 4.30252083 3.5 3.66085417 3.5 2.90135417 3.5 2.15585417 2.61158333.7896875 2.23008333.2366875 2.0125-.0788958333 1.4875-.0788958333 1.26991667.2366875.887833333.7896875 0 2.15585417 0 2.90135417 0 3.66085417.488833333 4.30252083 1.16666667 4.54402083M5.83333333 1.64952083C6.16933333 2.21535417 6.412 2.7234375 6.41666667 2.90135417 6.41666667 3.22335417 6.15475 3.4846875 5.83333333 3.4846875 5.51191667 3.4846875 5.25 3.22335417 5.25 2.9019375 5.25466667 2.72402083 5.49733333 2.2159375 5.83333333 1.64952083M5.25 4.54402083L5.25 5.81802083 6.41666667 5.81802083 6.41666667 4.54402083C7.09391667 4.30252083 7.58333333 3.66085417 7.58333333 2.90135417 7.58333333 2.15585417 6.69491667.7896875 6.31341667.2366875 6.09583333-.0788958333 5.57083333-.0788958333 5.35325.2366875 4.97116667.7896875 4.08333333 2.15585417 4.08333333 2.90135417 4.08333333 3.66085417 4.57216667 4.30252083 5.25 4.54402083'
							transform='translate(10.583 9.015)'
						/>
					);
					break;
				}
				case Api.ResourceSelectorId.TurningXX:
				case Api.ResourceSelectorId.TurningXX2:
				case Api.ResourceSelectorId.TurningXX3:
				case Api.ResourceSelectorId.TurningXX4:
				case Api.ResourceSelectorId.TurningXX5:
				case Api.ResourceSelectorId.HappyBirthday:
				case Api.ResourceSelectorId.Turning65: {
					circleStroke =
						t.resourceSelector === Api.ResourceSelectorId.Turning65
							? noteTintColor
							: t.resourceSelector === Api.ResourceSelectorId.TurningXX ||
									t.resourceSelector === Api.ResourceSelectorId.TurningXX2 ||
									t.resourceSelector === Api.ResourceSelectorId.TurningXX3 ||
									t.resourceSelector === Api.ResourceSelectorId.TurningXX4 ||
									t.resourceSelector === Api.ResourceSelectorId.TurningXX5
								? campaignTintColor
								: emailActivityTintColor;
					path = (
						<path
							fill={circleStroke}
							d='M9.91666667 12.8183125L1.75 12.8183125C1.42858333 12.8183125 1.16666667 12.5563958 1.16666667 12.2349792L1.16666667 10.7433958C1.51141667 10.9446458 1.90633333 11.0683125 2.33333333 11.0683125 3.02925 11.0683125 3.65575 10.7620625 4.08333333 10.2773125 4.51091667 10.7620625 5.13741667 11.0683125 5.83333333 11.0683125 6.52925 11.0683125 7.15575 10.7620625 7.58333333 10.2773125 8.01091667 10.7620625 8.63741667 11.0683125 9.33333333 11.0683125 9.76033333 11.0683125 10.15525 10.9446458 10.5 10.7433958L10.5 12.2349792C10.5 12.5563958 10.2380833 12.8183125 9.91666667 12.8183125L9.91666667 12.8183125zM10.5 8.73497917C10.5 9.37839583 9.97675 9.90164583 9.33333333 9.90164583 8.68991667 9.90164583 8.16666667 9.37839583 8.16666667 8.73497917 8.16666667 8.41297917 7.90533333 8.15164583 7.58333333 8.15164583 7.26133333 8.15164583 7 8.41297917 7 8.73497917 7 9.37839583 6.47675 9.90164583 5.83333333 9.90164583 5.18991667 9.90164583 4.66666667 9.37839583 4.66666667 8.73497917 4.66666667 8.41297917 4.40533333 8.15164583 4.08333333 8.15164583 3.76133333 8.15164583 3.5 8.41297917 3.5 8.73497917 3.5 9.37839583 2.97675 9.90164583 2.33333333 9.90164583 1.68991667 9.90164583 1.16666667 9.37839583 1.16666667 8.73497917L1.16666667 7.5683125 10.5 7.5683125 10.5 8.73497917zM11.0833333 6.40164583L.583333333 6.40164583C.261333333 6.40164583 0 6.66297917 0 6.98497917L0 12.2349792C0 13.1998125.785166667 13.9849792 1.75 13.9849792L9.91666667 13.9849792C10.8815 13.9849792 11.6666667 13.1998125 11.6666667 12.2349792L11.6666667 6.98497917C11.6666667 6.66297917 11.4053333 6.40164583 11.0833333 6.40164583L11.0833333 6.40164583zM9.91666667 1.64952083C10.2526667 2.21535417 10.4953333 2.7234375 10.5 2.90135417 10.5 3.22335417 10.2380833 3.4846875 9.91666667 3.4846875 9.59525 3.4846875 9.33333333 3.22335417 9.33333333 2.9019375 9.338 2.72402083 9.58066667 2.2159375 9.91666667 1.64952083M9.33333333 4.54402083L9.33333333 5.81802083 10.5 5.81802083 10.5 4.54402083C11.17725 4.30252083 11.6666667 3.66085417 11.6666667 2.90135417 11.6666667 2.15585417 10.77825.7896875 10.39675.2366875 10.1791667-.0788958333 9.65416667-.0788958333 9.43658333.2366875 9.0545.7896875 8.16666667 2.15585417 8.16666667 2.90135417 8.16666667 3.66085417 8.6555 4.30252083 9.33333333 4.54402083M1.75 1.64952083C2.086 2.21535417 2.32866667 2.7234375 2.33333333 2.90135417 2.33333333 3.22335417 2.07141667 3.4846875 1.75 3.4846875 1.42858333 3.4846875 1.16666667 3.22335417 1.16666667 2.9019375 1.17133333 2.72402083 1.414 2.2159375 1.75 1.64952083M1.16666667 4.54402083L1.16666667 5.81802083 2.33333333 5.81802083 2.33333333 4.54402083C3.01058333 4.30252083 3.5 3.66085417 3.5 2.90135417 3.5 2.15585417 2.61158333.7896875 2.23008333.2366875 2.0125-.0788958333 1.4875-.0788958333 1.26991667.2366875.887833333.7896875 0 2.15585417 0 2.90135417 0 3.66085417.488833333 4.30252083 1.16666667 4.54402083M5.83333333 1.64952083C6.16933333 2.21535417 6.412 2.7234375 6.41666667 2.90135417 6.41666667 3.22335417 6.15475 3.4846875 5.83333333 3.4846875 5.51191667 3.4846875 5.25 3.22335417 5.25 2.9019375 5.25466667 2.72402083 5.49733333 2.2159375 5.83333333 1.64952083M5.25 4.54402083L5.25 5.81802083 6.41666667 5.81802083 6.41666667 4.54402083C7.09391667 4.30252083 7.58333333 3.66085417 7.58333333 2.90135417 7.58333333 2.15585417 6.69491667.7896875 6.31341667.2366875 6.09583333-.0788958333 5.57083333-.0788958333 5.35325.2366875 4.97116667.7896875 4.08333333 2.15585417 4.08333333 2.90135417 4.08333333 3.66085417 4.57216667 4.30252083 5.25 4.54402083'
							transform='translate(10.583 9.015)'
						/>
					);
					break;
				}
				case Api.ResourceSelectorId.NewPolicy:
				case Api.ResourceSelectorId.PolicyRenew:
				case Api.ResourceSelectorId.FinancialReview: {
					circleStroke = kitTintColor;
					path = (
						<g fill={circleStroke} transform='translate(9.23 9.386)'>
							<path d='M3.90466667,3.63833333 C4.294,3.97633333 4.34733333,4.57366667 3.99933333,4.97566667 C3.67066667,5.35366667 3.04266667,5.39833333 2.664,5.069 C2.344,4.79166667 1.99266667,3.89166667 1.74,3.03633333 C2.73066667,3.20033333 3.67266667,3.437 3.90466667,3.63833333 M3.284,6.63433333 C3.94533333,6.63433333 4.57266667,6.34833333 5.006,5.849 C5.40533333,5.38966667 5.602,4.80166667 5.55866667,4.19366667 C5.516,3.58633333 5.23866667,3.03166667 4.77933333,2.63166667 C3.896,1.865 1.07133333,1.593 -1.13686838e-13,1.47366667 C0.144,2.14033333 0.698,5.12766667 1.79,6.07633333 C2.20466667,6.43566667 2.73533333,6.63433333 3.284,6.63433333' />
							<path d='M7.87733333,2.64066667 C8.25066667,2.25733333 9.43333333,1.88266667 10.5006667,1.64266667 C10.2386667,2.846 9.87733333,4.028 9.598,4.31466667 C9.132,4.79333333 8.372,4.798 7.9,4.338 C7.426,3.876 7.416,3.11466667 7.87733333,2.64066667 L7.87733333,2.64066667 Z M8.62266667,12.2806667 L4.25,12.2806667 L3.36133333,9.614 L9.51133333,9.614 L8.62266667,12.2806667 Z M7.314,5.56933333 C7.73133333,5.85466667 8.22266667,6.01133333 8.73733333,6.01133333 C9.42733333,6.01133333 10.072,5.73866667 10.5533333,5.24466667 C11.4586667,4.316 11.9546667,1.18066667 12.154,0 C11.4873333,0.104666667 8.05466667,0.547333333 6.922,1.71 C6.45,2.19533333 6.19533333,2.83466667 6.204,3.51133333 C6.20933333,3.85466667 6.282,4.18533333 6.41533333,4.49 C6.00666667,5.07466667 5.76933333,5.722 5.76933333,6.328 L5.76933333,8.28066667 L2.436,8.28066667 C2.222,8.28066667 2.02066667,8.384 1.89533333,8.558 C1.77,8.732 1.736,8.95533333 1.804,9.15866667 L3.13733333,13.1586667 C3.228,13.4306667 3.48266667,13.614 3.76933333,13.614 L9.10266667,13.614 C9.39,13.614 9.64466667,13.4306667 9.73533333,13.1586667 L11.0686667,9.15866667 C11.1366667,8.95533333 11.102,8.732 10.9766667,8.558 C10.8513333,8.384 10.6506667,8.28066667 10.436,8.28066667 L7.10266667,8.28066667 L7.10266667,6.328 C7.10266667,6.09266667 7.182,5.83066667 7.314,5.56933333 L7.314,5.56933333 Z' />
						</g>
					);
					break;
				}

				case Api.ResourceSelectorId.Custom1:
				case Api.ResourceSelectorId.Custom2:
				case Api.ResourceSelectorId.Custom3:
				case Api.ResourceSelectorId.Custom4:
				case Api.ResourceSelectorId.Custom5:
				case Api.ResourceSelectorId.Custom6:
				case Api.ResourceSelectorId.Custom7:
				case Api.ResourceSelectorId.Custom8:
				case Api.ResourceSelectorId.Custom9:
				case Api.ResourceSelectorId.Custom10: {
					circleStroke = customAutomationTint;
					path = (
						<path
							transform='translate(8, 7)'
							d='M14.3976,14.4 L1.6,14.4 L1.6,5.6 L14.3992,5.6 L14.3976,14.4 Z M14.4,2.4 L13.6,2.4 L13.6,0 L12,0 L12,4 L11.2,4 L11.2,2.4 L5.6,2.4 L5.6,0 L4,0 L4,4 L3.2,4 L3.2,2.4 L1.6,2.4 C0.7176,2.4 0,3.1184 0,4 L0,14.4 C0,15.2824 0.7176,16 1.6,16 L14.4,16 C15.2824,16 16,15.2824 16,14.4 L16,4 C16,3.1184 15.2824,2.4 14.4,2.4 L14.4,2.4 Z'
							fill={circleStroke}
						/>
					);
					break;
				}
				default: {
					break;
				}
			}
			break;
		}
		case Api.AutomationTriggerType.Tag: {
			circleStroke = brandPrimary;
			path = (
				<g fill={circleStroke} transform='translate(8 7)'>
					<path d='M1.5,8.689425 L9,16.189425 L13.1895,11.999925 L5.6895,4.499925 L1.5,4.499925 L1.5,8.689425 Z M9,17.999925 C8.808,17.999925 8.616,17.926425 8.46975,17.780175 L0.21975,9.530175 C0.0795,9.389925 0,9.198675 0,8.999925 L0,3.749925 C0,3.335925 0.336,2.999925 0.75,2.999925 L6,2.999925 C6.19875,2.999925 6.38925,3.079425 6.53025,3.219675 L14.78025,11.469675 C15.0735,11.762925 15.0735,12.236925 14.78025,12.530175 L9.53025,17.780175 C9.384,17.926425 9.192,17.999925 9,17.999925 L9,17.999925 Z' />
					<path d='M5.25 6.75C5.25 7.57725 4.578 8.25 3.75 8.25 2.9205 8.25 2.25 7.57725 2.25 6.75 2.25 5.92125 2.9205 5.25 3.75 5.25 4.578 5.25 5.25 5.92125 5.25 6.75M15.21975 9.53025L7.1895 1.5 2.25 1.5 2.25 1.77635684e-15 7.5 1.77635684e-15C7.69875 1.77635684e-15 7.88925.07875 8.03025.21975L16.28025 8.46975 15.21975 9.53025z' />
				</g>
			);
			break;
		}
		default: {
			return null;
		}
	}
	const cStroke = propsCircleStroke || circleStroke;
	return (
		<SvgIcon className={`automation-step-icon ${className || ''} ${css(...(styles || []))}`} height={32} width={32}>
			<g fill='none' fillRule='evenodd'>
				{!!cStroke && <circle cx='16' cy='16' r='15' stroke={cStroke} />}
				{path}
			</g>
		</SvgIcon>
	);
};
